import React,{useState} from "react";
import { useEffect } from "react";
import { Carousel } from "react-responsive-carousel";


const IdealCarousel =(props) => {
    const [images,setImages] = useState([]);
    
    var image= ["https://res.cloudinary.com/custoshoe7/image/upload/v1697791175/z7qnns4sexcjtdplx0tk.jpg", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532882/lzjazs5jiozzdzkwo5yg.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532878/r1c0gghjplmnpjkmx7gv.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532871/up4alkzrccsmdnwk5b89.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532873/fzneihk5f78oskarbe4u.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532884/gynkcxmr6fyvkaoqcnln.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532860/bqzfsowmufaapn4tzyyz.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532879/il973ikwgcqf8xsw03dr.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532893/ljcy1snr7qpxxvhqwux7.png"];
    var copyImage = ["https://res.cloudinary.com/custoshoe7/image/upload/v1697791175/z7qnns4sexcjtdplx0tk.jpg", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532882/lzjazs5jiozzdzkwo5yg.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532878/r1c0gghjplmnpjkmx7gv.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532871/up4alkzrccsmdnwk5b89.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532873/fzneihk5f78oskarbe4u.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532884/gynkcxmr6fyvkaoqcnln.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532860/bqzfsowmufaapn4tzyyz.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532879/il973ikwgcqf8xsw03dr.png", "https://res.cloudinary.com/custoshoe7/image/upload/v1696532893/ljcy1snr7qpxxvhqwux7.png"];

    useEffect(() => {
        var slicedImages = [];
        var index = Math.floor(Math.random() * image.length-1);
        console.log(index);
        if(index-4<0){
            slicedImages = image.slice(index,index+4);
        }else{
            slicedImages = image.slice(index-4,index);
        }
      
        setImages(slicedImages);
        image=[...copyImage];
      }, []);
    return (
    <div className="flex h-1/2 m-1">
        {
            images.map(item=>{
                return (
                    <div className="m-1">
                        <img src={item} alt="image" />
                    </div>
                )
            })
        }
    </div>
    )
    
}

export default IdealCarousel;